const ApiRoutes = {
  AUTH_LOGIN: '/auth/login',
  AUTH_LOGOUT: '/auth/logout',
  AUTH_PASSWORD: '/auth/password',
  AUTH_PASSWORD_CONFIRM: '/auth/reset',

  // --- RESERVATIONS (ADMIN) ---
  RESERVATIONS_ADMIN_GET: (placeId, date, resourceId, userId) =>
    `/reservations/admin?placeId=${placeId}&date=${date}` +
    (resourceId ? `&resourceId=${resourceId}` : '') +
    (userId ? `&userId=${userId}` : ''),
  RESERVATIONS_ADMIN_DELETE: (id) => `/reservations/admin/${id}`,
  RESERVATIONS_ADMIN_DELETE_MANY: (ids) =>
    `/reservations/admin?${ids.map((i) => `ids=${i}`).join('&')}`,
  RESERVATIONS_ADMIN_POST: '/reservations/admin',

  // --- RESERVATIONS (USER) ---
  RESERVATIONS_FUTURE: (placeId, resourceId) =>
    `/reservations/future?placeId=${placeId}` +
    (resourceId ? `&resourceId=${resourceId}` : ''),
  RESERVATIONS: (placeId, date, resourceId) =>
    `/reservations?placeId=${placeId}&date=${date}` +
    (resourceId ? `&resourceId=${resourceId}` : ''),
  RESERVATIONS_ALL: () => `/reservations`,
  RESERVATIONS_POST: '/reservations',
  RESERVATIONS_DELETE: (reservationId) => `/reservations/${reservationId}`,
  RESERVATIONS_MERGED_DELETE: (queryString) => `/reservations?${queryString}`,
  RESERVATIONS_FUTURE_DAYS: (queryString) =>
    `/reservations/admin/future-days?${queryString}`,
  RESERVATIONS_BLOCKED: (blockId) => `/reservations/admin/blocks/${blockId}`,

  /**
   * @param {Object} [options]
   * @param {Boolean} [options.past] Load past reservations, default false
   * @param {Number} [options.placeId] Place ID
   * @param {Number} [options.resourceId] Resource ID
   * @param {Number} [options.limit] Limit of results, default 10
   * @param {Number} [options.offset] Offset of results, default 0
   */
  RESERVATIONS_ME: (options = {}) => {
    return `/reservations/me?${Object.keys(options)
      .map((key) => `${key}=${options[key]}`)
      .join('&')}`
  },

  // --- SLOTS
  /**
   * @param {Number} placeId
   * @param {String} date
   * @param {Number | null} resourceId
   * @returns
   */
  SLOTS: (placeId, date, resourceId = null) =>
    `/places/${placeId}/slots?date=${date}` +
    (resourceId ? `&resourceId=${resourceId}` : ''),
  /**
   * @param {Number} placeId
   * @param {String} date
   * @param {Number} resourceId
   * @returns
   */
  SLOTS_ADMIN: (placeId, date, resourceId = null) =>
    `/places-admin/${placeId}/slots?date=${date}` +
    (resourceId ? `&resourceId=${resourceId}` : ''),

  // --- PLACES
  RESERVATIONS_GET_PLACES: '/places',
  RESERVATIONS_GET_PLACE: (placeId) => `/places/${placeId}`,
  PLACES_POST: '/places',
  PLACES_PUT: (id) => `/places/${id}`,

  // ── BLOCKS (ADMIN) ─────────────────────────────────────────────
  BLOCKS_ADMIN_GET: (placeId, resourceId) =>
    `/places/${placeId}/blocks` +
    (resourceId ? `?resourceId=${resourceId}` : ''),
  BLOCKS_ADMIN_POST: (placeId) => `/places/${placeId}/blocks`,
  BLOCKS_ADMIN_DELETE: (placeId, blockId) =>
    `/places/${placeId}/blocks/${blockId}`,

  CHAT_GET_USERS: '/users/role/user',
  CHAT_GET_MESSAGES_FOR_CONCIERGE: (roomId) =>
    `/messages/concierge?room=${roomId}`,
  CHAT_GET_MESSAGES_FOR_USER: `/messages`,
  CHAT_POST_MESSAGE: '/messages',
  CHAT_PATCH_MESSAGE: '/messages/read',
  CHAT_GET_MESSAGES_CURSOR: (queryString) => `/messages?${queryString}`,
  TASKS_POST_TASK: '/tasks',
  TASKS_PATCH_TASK: (taskId) => `/tasks/${taskId}`,
  TASKS_GET_FOR_USER: (userId) => `/tasks/concierge?userId=${userId}`,
  DOCUMENTS_GET_STRUCTURE: (userId) => `/documents/structure/${userId}`,
  DOCUMENTS_POST_FILES: '/documents/files',
  DOCUMENTS_POST_FOLDER: '/documents/folders',
  DOCUMENTS_DELETE_FOLDER: (folderId) => `/documents/folders/${folderId}`,
  DOCUMENTS_DELETE_FILE: (fileId) => `/documents/files/${fileId}`,
  OPEN_DOOR: '/users/control-door',
  ELEVATOR_POST_RESERVATION: '/users/reserve-elevator',
  ELEVATOR_GET_RESERVATIONS: '/users/reserve-upcoming',
  ELEVATOR_DELETE_RESERVATION: (reservationId) =>
    `/users/reserve-elevator/${reservationId}`,
  ELEVATOR_LOGS: '/users/elevator-dispatches',
  ELEVATOR_TIMELINE_LOGS: ({ from, to } = {}) => {
    const params = []
    if (from) params.push(`from=${encodeURIComponent(from)}`)
    if (to) params.push(`to=${encodeURIComponent(to)}`)
    return `/users/elevator-dispatch-timeline${params.length ? `?${params.join('&')}` : ''}`
  },
  USERS_GET: '/users/admin/users',
  UNITS_GET: '/users/admin/units',
  UNIT_PUT: (id) => `/users/admin/units/${id}`,
  USER_PATCH: (userId) => `/users/admin/users/${userId}`,
  USER_DELETE: (userId) => `/users/admin/users/${userId}`,
  USER_CREATE: '/auth/register',
  NEWS_GET: '/articles',
  NEWS_POST: '/articles',
  NEWS_ITEM: (id) => `/articles/${id}`,
  NEWS_DELETE_IMAGE: (id, img) =>
    `/articles/${id}/images/${encodeURIComponent(img)}`,

  // Banners
  NEWS_BANNER_GET: (articleId) => `/articles/${articleId}/banners`,
  NEWS_BANNERS_POST: (articleId) => `/articles/${articleId}/banners`,
  BANNER_DELETE: (bannerId) => `/banners/${bannerId}`,

  PLACE_RESOURCES_GET: (placeId) => `/places/${placeId}/resources`
}

export default ApiRoutes
